//@flow
import {
    bulkLocationGeocodeEdit as bulkLocationGeocodeEditApi,
    locationBulkGeocodeVerify
} from 'common/middleware/api';
import I18nHelper from 'common/helpers/I18nHelper';
import { showToast } from 'common/redux/actions/toast';
import { ToastTypes } from 'common/components/core/toast/Toast';
import type { Dispatch } from 'redux';

const translationsNamespace = ['entityManagement'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

class LocationGeocodeActions {
    static EDIT_LOCATION_LATLNG_START = 'EDIT_LOCATION_LATLNG_START';
    static EDIT_LOCATION_LATLNG_SUCCESS = 'EDIT_LOCATION_LATLNG_SUCCESS';
    static EDIT_LOCATION_LATLNG_ERROR = 'EDIT_LOCATION_LATLNG_ERROR';
    static VERIFY_LOCATION_START = 'VERIFY_LOCATION_START';
    static VERIFY_LOCATION_SUCCESS = 'VERIFY_LOCATION_SUCCESS';
    static VERIFY_LOCATION_ERROR = 'VERIFY_LOCATION_ERROR';
    static CLEAR_LOCATION_VALIDATE_GEOCODE_DATA =
        'CLEAR_LOCATION_VALIDATE_GEOCODE_DATA';
    static VALIDATE_LOCATION_GEOCODE_START = 'VALIDATE_LOCATION_GEOCODE_START';
    static VALIDATE_LOCATION_GEOCODE_SUCCESS =
        'VALIDATE_LOCATION_GEOCODE_SUCCESS';
    static VALIDATE_LOCATION_GEOCODE_ERROR = 'VALIDATE_LOCATION_GEOCODE_ERROR';

    static startEditLatLng = (params, body) => {
        return {
            type: LocationGeocodeActions.EDIT_LOCATION_LATLNG_START,
            params,
            body
        };
    };
    static editLatLngSuccess = (params, body) => {
        return {
            type: LocationGeocodeActions.EDIT_LOCATION_LATLNG_SUCCESS,
            params,
            body
        };
    };
    static editLatLngError = (params, body, error) => {
        return {
            type: LocationGeocodeActions.EDIT_LOCATION_LATLNG_ERROR,
            params,
            body,
            error
        };
    };
    static startVerification = (params, body) => {
        return {
            type: LocationGeocodeActions.VERIFY_LOCATION_START,
            params,
            body
        };
    };
    static verificationSuccess = (params, body) => {
        return {
            type: LocationGeocodeActions.VERIFY_LOCATION_SUCCESS,
            params,
            body
        };
    };
    static verificationError = (params, body, error) => {
        return {
            type: LocationGeocodeActions.VERIFY_LOCATION_ERROR,
            params,
            body,
            error
        };
    };
    static clearGeocodeValidationData = (params, body) => {
        return {
            type: LocationGeocodeActions.CLEAR_LOCATION_VALIDATE_GEOCODE_DATA,
            params,
            body
        };
    };
    static geocodeValidationStart = (params, body) => {
        return {
            type: LocationGeocodeActions.VALIDATE_LOCATION_GEOCODE_START,
            params,
            body
        };
    };
    static geocodeValidationSuccess = (params, body, response) => {
        return {
            type: LocationGeocodeActions.VALIDATE_LOCATION_GEOCODE_SUCCESS,
            params,
            response,
            body
        };
    };
    static geocodeValidationError = (params, body, error) => {
        return {
            type: LocationGeocodeActions.VALIDATE_LOCATION_GEOCODE_ERROR,
            params,
            body,
            error
        };
    };
    static editEntityLatLng(params: { clientId: string }, body) {
        return (dispatch: Dispatch<*>) => {
            dispatch(LocationGeocodeActions.startEditLatLng(params, body));
            return new Promise((resolve, reject) => {
                bulkLocationGeocodeEditApi
                    .post(params, body)
                    .then(() => {
                        dispatch(
                            LocationGeocodeActions.editLatLngSuccess(
                                params,
                                body
                            )
                        );
                        const toast = {
                            message: nsTranslate(
                                'locationTable.bulkEditSuccessToast',
                                { count: body.edits.length }
                            ),
                            type: ToastTypes.Success
                        };
                        dispatch(showToast(toast, params));
                        resolve();
                    })
                    .catch(error => {
                        dispatch(
                            LocationGeocodeActions.editLatLngError(
                                params,
                                body,
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast, params));
                        reject(error);
                    });
            });
        };
    }

    static verifyEntity(params: { clientId: string }, body) {
        return (dispatch: Dispatch<*>) => {
            dispatch(LocationGeocodeActions.startVerification(params, body));
            return new Promise((resolve, reject) => {
                bulkLocationGeocodeEditApi
                    .post(params, body)
                    .then(() => {
                        dispatch(
                            LocationGeocodeActions.verificationSuccess(
                                params,
                                body
                            )
                        );
                        const toast = {
                            message: nsTranslate(
                                'locationTable.bulkEditSuccessToast',
                                { count: body.edits.length }
                            ),
                            type: ToastTypes.Success
                        };
                        dispatch(showToast(toast, params));
                        resolve();
                    })
                    .catch(error => {
                        dispatch(
                            LocationGeocodeActions.verificationError(
                                params,
                                body,
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast, params));
                        reject(error);
                    });
            });
        };
    }

    static validateGeocodes(params: { clientId: string }, locationIds) {
        return (dispatch: Dispatch<*>) => {
            const body = { locationIds };
            dispatch(
                LocationGeocodeActions.geocodeValidationStart(params, body)
            );
            return new Promise((resolve, reject) => {
                locationBulkGeocodeVerify
                    .post(params, body)
                    .then(response => {
                        dispatch(
                            LocationGeocodeActions.geocodeValidationSuccess(
                                params,
                                body,
                                response
                            )
                        );
                        resolve();
                    })
                    .catch(error => {
                        dispatch(
                            LocationGeocodeActions.geocodeValidationError(
                                params,
                                body,
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast, params));
                        reject(error);
                    });
            });
        };
    }
}

export default LocationGeocodeActions;
